import request from '@/utils/request'

//单位基本信息


//查询单位信息
export function getQyxx() {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/yzddw/getQyxxByLoginUser"
  })
}
export function getQyxxById(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/yzddw/getQyxxById/"+ id
  })
}

//获取化学品信息
export function getHxpxx(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/yzddw/getHxpxx",
    data: data
  })
}

//获取化学品信息（根据单位追按）
export function getHxpxxByDwid(data,dwId) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/yzddw/getHxpxx/"+dwId,
    data: data
  })
}

//根据证件类型获取数据列表
export function getFjsjxxByZjlx(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/yzddw/getFjsjxxByZjlx/" + id
  })
}
//根据证件类型和单位主键获取数据列表
export function getFjsjxxByZjlxAndDwid(id,dwId) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/yzddw/getFjsjxxByZjlx/" + id+"/"+dwId
  })
}
//获取单位附件数据详情
export function getFjxxByFjsjId(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/yzddw/getFjxxByFjsjId/" + id
  })
}
//获取单位附件数据详情
export function getFjxxByFjsjIdAndDwId(id,dwId) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/yzddw/getFjxxByFjsjId/" + id+"/"+dwId
  })
}
